import {
  apiClient
} from "./chunk-HCVPNQUB.mjs";

// src/ops/cronApi.ts
import { CronService } from "@maat/api-shared";
var CRON_SERVICE_PATH = {
  [CronService.Main]: "/main",
  [CronService.Booking]: "/booking",
  [CronService.Payment]: "/payment",
  [CronService.IcalSync]: "/ical-sync",
  [CronService.Pricing]: "/pricing",
  [CronService.Chat]: "/chat"
};
var base = (service) => `${CRON_SERVICE_PATH[service]}/api/admin/cron`;
var job = (service, jobName) => `${base(service)}/${encodeURIComponent(jobName)}`;
var cronApi = {
  getSummary: async (service) => apiClient.get(base(service)),
  getRuns: async (service, jobName, params) => apiClient.get(`${job(service, jobName)}/runs`, { params }),
  trigger: async (service, jobName) => apiClient.post(`${job(service, jobName)}/trigger`),
  updateSchedule: async (service, jobName, cronExpression) => apiClient.patch(`${job(service, jobName)}/schedule`, {
    cronExpression
  }),
  setEnabled: async (service, jobName, enabled) => apiClient.patch(`${job(service, jobName)}/enabled`, { enabled })
};

export {
  cronApi
};
